import { $createParagraphNode, $getRoot, $getSelection, $isRangeSelection } from "lexical";
import {
    $createHeadingNode,
    $isHeadingNode,
    type HeadingTagType,
} from "@lexical/rich-text";
import { $setBlocksType } from "@lexical/selection";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

import { useButtonState } from "../useButtonState";

type BlockOption = "paragraph" | HeadingTagType;

const OPTIONS: { value: BlockOption; label: string }[] = [
    { value: "paragraph", label: "Paragraph" },
    { value: "h1", label: "Heading 1" },
    { value: "h2", label: "Heading 2" },
    { value: "h3", label: "Heading 3" },
];

export function HeadingDropdown() {
    const [editor] = useLexicalComposerContext();
    const current = useButtonState<BlockOption>(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
            const top = selection.anchor.getNode().getTopLevelElement();
            if (top && $isHeadingNode(top)) {
                return top.getTag() as HeadingTagType;
            }
            return "paragraph";
        }
        const first = $getRoot().getFirstChild();
        if (first && $isHeadingNode(first)) {
            return first.getTag() as HeadingTagType;
        }
        return "paragraph";
    });

    return (
        <select
            className="rte-toolbar-select"
            value={current}
            onMouseDown={(e) => e.stopPropagation()}
            onChange={(e) => {
                const next = e.target.value as BlockOption;
                editor.update(() => {
                    const selection = $getSelection();
                    if (!$isRangeSelection(selection)) return;
                    $setBlocksType(selection, () =>
                        next === "paragraph"
                            ? $createParagraphNode()
                            : $createHeadingNode(next),
                    );
                });
            }}
            aria-label="Block style"
        >
            {OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </select>
    );
}
